import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import VideoList from './components/VideoList';
import PlatformBanner from './components/PlatformBanner';
import FAQSection from './components/FAQSection';
import { hotVideos, latestVideos } from '@/mocks/data';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" />

      <Navbar />

      <main>
        <article>
          <HeroSection />
        </article>

        <CategoryGrid />

        <VideoList
          title="热门推荐"
          subtitle="全网热播，大家都在看"
          icon="ri-fire-line"
          videos={hotVideos}
        />

        <PlatformBanner />

        <VideoList
          title="最近更新"
          subtitle="最新上线，抢先观看"
          icon="ri-timer-flash-line"
          videos={latestVideos}
          bgClass="bg-background-100"
          showPlatform={false}
        />

        <FAQSection />
      </main>

      <Footer />
    </>
  );
}